// extracted by mini-css-extract-plugin
export default {"musicLicensing":"MusicLicensingContainer-module_musicLicensing__M0CaR"};